import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4306310e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title font-montserrat-bold" }, null, -1))
const _hoisted_3 = { class: "tags font-montserrat-regular" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "ankeiler",
    onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mouseEnter && _ctx.mouseEnter(...args))),
    ref: "elem"
  }, [
    _createElementVNode("img", {
      src: _ctx.data.images?.tile,
      alt: _ctx.data.title
    }, null, 8, _hoisted_1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tags, (tag, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "tag",
          key: key
        }, _toDisplayString(tag), 1))
      }), 128))
    ])
  ], 544))
}